module.exports = __webpack_public_path__ + "img/fondo2.92412db5.png";